var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"home__container",attrs:{"fluid":"","grid-list-md":""}},[_vm._v("\n  Bem vindo ao Maestro CMS.\n")])}
var staticRenderFns = []

export { render, staticRenderFns }